<template>
  <div>
    <!-- <div v-if="searchable && searchPlace === 'top'"
         class="search-con search-con-top">
      <Select v-model="searchKey"  class="search-col">
        <Option v-for="item in arearIndexs"
                :value="item.key"
                :key="`search-col-${item.key}`">{{ item.title }}
        </Option>
      </Select>
      <Input @on-change="handleClear"
             clearable
             placeholder="输入关键字搜索"
             class="search-input"
             v-model="searchValue" />

      <Button @click="handleSearch"
              class="search-btn"
              type="primary"
              icon="ios-search">
        搜索</Button>

    </div>-->
    <Table
      :loading="loading"
      :border="showBorder"
      :stripe="showStripe"
      :show-header="showHeader"
      :height="fixedHeader ? 500 : ''"
      :size="tableSize"
      :data="tableData"
      :columns="tableColumns"
      :highlight-row="highlightRow"
      :editable="editable"
      :searchable="searchable"
      :searchPlace="searchPlace"
      tooltip-theme="dark"
      ref="selection"
      :show-footer="showFooter"
    >
      <template slot-scope="{ row, index }" slot="note">
        <Input type="text" v-model="editNote" v-if="editIndex === index" />
        <span v-else>{{ row.note }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="action">
        <!-- <Button v-if="editIndex === index"
                size="small"
        @click="editIndex = -1">取消</Button>-->
        <Button
          type="primary"
          size="small"
          style="margin-right: 5px;"
          class="isclick-btn"
        >
          <a :href="row.link" target="_blank">详情</a>
        </Button>
        <!-- <Button
          type="warning"
          size="small"
          v-if="editIndex === index"
          @click="notesave(row)"
        >保存</Button> -->
        <!-- <Button
          v-else-if="tableType!='black'"
          type="primary"
          size="small"
          style="margin-right: 5px"
          @click="noteedit(row,index)"
        >跟踪</Button> -->

        <!-- <Button
          type="primary"
          size="small"
          style="margin-right: 5px;"
          @click="selectme(row)"
          v-if="!row.selected"
        >保护</Button>
        <Button
          type="error"
          size="small"
          style="margin-right: 5px;"
          v-if="row.selected"
        >已保护</Button> -->
        <!-- <Button
          type="primary"
          class="black-button"
          size="small"
          style="margin-right: 5px"
          v-if="tableType!='black' && Number($store.state.user.lv) < 9"
          @click="blacksave(row,index)"
        >拉黑</Button> -->
        <!-- <Button
          type="primary"
          class="black-button"
          size="small"
          style="margin-right: 5px"
          v-if="tableType!='black'  && Number($store.state.user.lv) > 8"
          @click="blacksave(row,index)"
        >回收</Button> -->
        <!-- <Button
          type="primary"
          class="black-button"
          size="small"
          style="margin-right: 5px"
          v-if="tableType=='black'"
          @click="unblacksave(row,index)"
        >复活</Button> -->
        <!-- <Button type="error"
                size="small"
        @click="remove(index)">Delete</Button>-->
      </template>
    </Table>

    <div style="margin: 10px;overflow: hidden">
      <div style="float:left">
        <!-- <Button @click="handleSelectAll(true)">批量领取</Button>
        <Button @click="handleSelectAll(false)">取消批量领取</Button>-->
      </div>
      <div style="float: right;" v-if="showFooter">
        <Page
          :total="infoTotal"
          :page-size="rowNums"
          :current="curpage"
          show-total
          show-sizer
          show-elevator
          v-if="tableType == 'default'"
          @on-page-size-change="changePageSize"
          @on-change="changePage"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
import '_c/caijisystem/tables/search.less';
import expandRow from '_c/caijisystem/tables/table-expand.vue';
export default {
  name: 'allselected2',
  components: { expandRow },
  data () {
    return {
      tableData: [],
      sourceFilter: [
        { label: '58同城', value: '1' },
        { label: '赶集网', value: '2' }
      ],
      timeFilter: [],
      Areafilters: [
        {
          label: '黄浦',
          value: '黄浦'
        }
      ],
      showBorder: true, // 显示表格列边框
      showStripe: true, // 显示斑马线样式
      showHeader: true, // 显示表头
      showIndex: true, // 显示索引序号
      showExpand: false, // 显示简要介绍
      showCheckbox: false, // 显示复选框/
      showNoteTime: false, // 显示备注时间
      fixedHeader: false, // 固定表头
      highlightRow: true, // 高亮选择的行
      searchable: true,
      searchPlace: 'top',
      searchKey: '',
      searchValue: '',
      editIndex: -1,
      editNote: '',
      editable: true, // 全局设置是否可编辑

      loading: false,
      // tooltip: true,
      tableSize: 'small',
      showFooter: true,

      fromPage: 1,
      rowNums: 50,
      infoTotal: 0,
      isClicked: true,

      tableType: 'default',
      isAutoRefreshed: false,
      refreshTime: 120000
    };
  },
  computed: {
    arearIndexs () {
      let tables = this.tableColumns;
      let newTableColumns = [];

      for (let i = 0; i < tables.length; i++) {
        let item = tables[i];
        if (
          item.hasOwnProperty('key') &&
          item.key !== 'note' &&
          item.key !== 'noteTime' &&
          item.key !== 'time'
        ) {
          newTableColumns.push(tables[i]);
        }
      }

      return newTableColumns;
    },
    curpage () {
      return this.fromPage;
    },
    tableColumns () {
      let columns = [];

      if (this.showCheckbox) {
        columns.push({
          type: 'selection',
          width: 60,
          align: 'center'
        });
      }
      if (this.showIndex) {
        columns.push({
          type: 'index',
          width: 50,
          align: 'center'
        });
      }
      if (this.showExpand) {
        columns.push({
          type: 'expand',
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row
              }
            });
          }
        });
      }

      columns.push({
        title: '发布时间',
        key: 'time',
        sortable: true,
        width: 150,
        align: 'center'
      });
      columns.push({
        title: '标题',
        key: 'title',
        width: 'auto',
        minWidth: 220
      });

      columns.push({
        title: '区域',
        key: 'area',
        sortable: false,
        width: 'auto',
        minWidth: 180,
        align: 'center'
      });
      columns.push({
        title: '手机号',
        key: 'phone',
        width: 112,
        align: 'center'
      });
      columns.push({
        title: '编辑',
        key: 'user_name',
        width: '120',
        align: 'left',
        sortable: true
      });
      columns.push({
        title: '保护人',
        key: 'selected_user_id',
        width: '120',
        align: 'left',
        sortable: true
      });
      // if (this.showNoteTime || this.tableType === 'note') {
      //   columns.push({
      //     title: '备注时间',
      //     key: 'noteTime',
      //     width: 108,
      //     align: 'center',
      //     sortable: true
      //   });
      // }
      columns.push({
        title: '操作',
        slot: 'action',
        width: 230,
        align: 'center'
      });

      return columns;
    }
  },
  created () {
    this.getInfos(this.fromPage, this.rowNums);
    this.getInfoTotal();
  },
  mounted () {},
  methods: {
    note () {
      this.showExpand = true;
    },

    reload () {
      this.getInfos(this.fromPage, this.rowNums);
      this.getInfoTotal();
      this.showFooter = true;
      this.tableType = 'default';
    },

    gettime (value, row) {
      return row.time.indexOf(value) > -1;
    },

    getInfoTotal () {
      this.$axios
        .request({
          url: 'caiji/?s=info2.getlistcountWithSelectAll',
          method: 'GET'
        })
        .then(json => {
          console.log(json);
          this.infoTotal = Number(json.data.data);
        });
    },

    // 获取列表信息
    getInfos (fromPage, rowNums) {
      this.loading = true;
      let userId = this.$store.state.user.userId;
      this.$axios
        .request({
          url:
            'caiji/?s=info2.getListWithSelectedAll&selected=1&userId=' +
            userId +
            '&from=' +
            fromPage +
            '&nums=' +
            rowNums,
          method: 'GET'
        })
        .then(json => {
          console.log('allselected====', json);
          json.data.data.forEach(item => {
            item.isClick = false;
          });
          this.tableType = 'default';
          this.tableData = json.data.data;

          this.loading = false;
        });
    },

    handleSelectAll (status) {
      this.$refs.selection.selectAll(status);
    },

    goto (data) {
      console.log('gotOdata', data);
      window.open(data.link);
      data.isClick = true;
    },
    selectmeBatch (data) {
      console.log('data', data);
    },
    changePage (pageNumber) {
      // this.fromPage = pageNumber;
      // TODO:根据tableType来调用不同的方法带分页功能
      this.fromPage = pageNumber;
      this.getInfos(pageNumber, this.rowNums);
      // console.log('下页数据', pageNumber);
    },
    changePageSize (pageSize) {
      // console.log('pageSize', pageSize)
      this.rowNums = pageSize;
      // console.log('frompage', this.fromPage)
      this.getInfos(this.fromPage, this.rowNums);
    }
  }
};
</script>
<style scoped>
.notewithother {
  border: 1px solid red;
}
.note-input {
  width: 100%;
}
.black-button {
  background: #141414;
}

a {
  width: 100%;
  height: 100%;
}
a:link {
  color: white;
}
a:visited {
  color: #ff9900;
  /* color: white; */
  background: grey;
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
}
a:hover {
  display: block;
  color: white;
  background: grey;
  width: 100%;
  height: 100%;
  z-index: 10;
}
.refresh {
  width: auto;
  height: 24px;
  line-height: 24px;
  margin-left: 20px;
}
</style>
